// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { MonthlyDeal } from "@bg/App/Services/MonthlyDealsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type MonthlyDealsState = {
    monthlyDeals: MonthlyDeal[];
    isLoading: boolean;
};

export type xMonthlyDealsState = {
    xMonthlyDelas: MonthlyDealsState;
};

const initialMonthlyDealsState: MonthlyDealsState = {
    monthlyDeals: [],
    isLoading: false,
};

const xMonthlyDelas = createTypedReducerWithImmer(initialMonthlyDealsState, {
    "xMonthlyDeals/BeginLoadMonthlyDeals": (draft: Draft<MonthlyDealsState>) => {
        draft.isLoading = true;
    },
    "xMonthlyDeals/CompleteLoadMonthlyDeals": (
        draft: Draft<MonthlyDealsState>,
        action: { monthlyDeals: MonthlyDeal[] },
    ) => {
        draft.monthlyDeals = action.monthlyDeals!;
        draft.isLoading = false;
    },
});

(reducers as any).xMonthlyDelas = xMonthlyDelas;

type xMonthlyDelasReducers = {
    monthlyDeals: typeof xMonthlyDelas;
};

export type xMonthlyDelasActions = Parameters<xMonthlyDelasReducers[keyof xMonthlyDelasReducers]>[1] | AnyAction;
